const onlyPostal = value =>
  /^(\d{1,2}|\d{2}[.]{0,1}|\d{2}[.]{0,1}\d{1,3}|\d{2}[.]{0,1}\d{3}[-]{0,1}|\d{2}[.]{0,1}\d{3}[-]{0,1}\d{1,3})$/g.test(value) || value === '';

export default onlyPostal;
